module.exports = __webpack_public_path__ + "static/gnome_rock_wizard_male_DMG-94465720214b00022e3bb56dfd738213.png";